
import { memo } from "react"
import Config from "../config"

const AppLogo = () => {
    return <img alt="logo" className="logo" src={Config.AppLogo} />
}

export default memo(AppLogo)